function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2663_928)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.5 9.49999H5.5V21.5H2.5C2.23478 21.5 1.98043 21.3946 1.79289 21.2071C1.60536 21.0196 1.5 20.7652 1.5 20.5V10.5C1.5 10.2348 1.60536 9.98042 1.79289 9.79288C1.98043 9.60535 2.23478 9.49999 2.5 9.49999ZM7.793 8.20699L14.193 1.80699C14.2781 1.72168 14.3911 1.66996 14.5112 1.66132C14.6314 1.65269 14.7506 1.68772 14.847 1.75999L15.7 2.39999C15.9369 2.57783 16.1158 2.82184 16.2143 3.10125C16.3127 3.38065 16.3262 3.68293 16.253 3.96999L15.1 8.49999H21.5C22.0304 8.49999 22.5391 8.7107 22.9142 9.08578C23.2893 9.46085 23.5 9.96956 23.5 10.5V12.604C23.5003 12.8654 23.4493 13.1242 23.35 13.366L20.255 20.881C20.1795 21.0642 20.0513 21.2209 19.8866 21.3311C19.7219 21.4413 19.5282 21.5001 19.33 21.5H8.5C8.23478 21.5 7.98043 21.3946 7.79289 21.2071C7.60536 21.0196 7.5 20.7652 7.5 20.5V8.91399C7.50006 8.64879 7.60545 8.39448 7.793 8.20699Z",
  fill: "#CF5285"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2663_928"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(0.5 0.5)"
})));

function SvgActivitiesOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivitiesOn);
export default __webpack_public_path__ + "static/media/activities-on.189ab1ba1c53365313ab307d3976b59d.svg";
export { ForwardRef as ReactComponent };